$(document).ready(function(){
    $(".js-open-form").colorbox();
    $(".open-requests-form").colorbox();
    $(".open-state-form").colorbox({inline:true})
    $(".js-open-image").colorbox({maxWidth:'95%', maxHeight:'95%'});

    $('input, select').styler();


    if ($.cookie("express-news") == undefined) {
        $(".js-express-news").removeClass('hide');
    }
    $(".js-express-news_close").click(function() {
        $(".js-express-news").hide();
        $.cookie("express-news", 1, { expires: 1, path: '/' });
        return false;
    });
    function setHeaderPadding() {
        $('.header-main').css({
            'padding-top': $('.pre-header').height()
        })
    }
    $(window).on('resize', function() {
        setHeaderPadding();
    });
    setHeaderPadding();




    $(".js-metismenu").metisMenu({
        doubleTapToGo: true
    });
    $(".header-nav_toggle").click(function() {
        $(this).toggleClass('opened');
        $('.header-nav_menu').toggleClass('opened');
        return false;
    });
    $(".header-nav_menu li.parent > a > span").click(function() {
        $(this).parent().parent().toggleClass('opened');
        $(this).parent().parent().children('ul').toggleClass('collapse');
        return false;
    });
    $(".header-nav_menu li.parent li.parent > a").click(function() {
        $(this).parent().toggleClass('opened');
        $(this).parent().children('ul').toggleClass('collapse');
        return false;
    });


    var max_top_offset = $(".navigation-wrapper").offset().top + $(".navigation-wrapper").height() + 5;
    $(".navigation-wrapper ulli ul li ul").each(function(index) {
        var top_offset = $(this).offset().top;
        var x_top = $(this).height() / 2;

        if ((top_offset - x_top) > max_top_offset) {
            $(this).css({ top: '-' + (x_top - 23) + 'px' });
        }
        else {
            $(this).css({ top: '-' + (top_offset - max_top_offset - 23) + 'px' });
        }
    });

    $(".navigation-wrapper .level-2").each(function(index) {
        var tr = $(this).offset().left + $(this).outerWidth();

        var tr_cntr = $(".navigation-wrapper .container").offset().left + $(".navigation-wrapper .container").outerWidth();
        if (tr > tr_cntr) {
            $(this).css({
                left: 'auto',
                right: '0px'
            });
        }
    });

    $(document).click(function() {
        // Закрываем всё
        //if ('.header-nav ul').hasClass()
        $(".header-nav_toggle").removeClass('opened');
        $(".header-nav_menu>ul").removeClass('opened');
    });



    window.last_scroll_position = 0;

    var scroll_to_top = $('#scroll_to_top');
    var last_position = 0;
    var show = false;
    var is_show = false;

    scroll_to_top.on('click', function(e){
        e.preventDefault();
        if(scroll_to_top.hasClass('back-down')){
            scroll_to_top.attr('title', 'Наверх').removeClass('back-down');
            $.scrollTo( window.last_scroll_position, 700,  { axis: 'y' } );
            window.last_scroll_position = 0;
        }else{
            window.last_scroll_position = window.scrollY;
            scroll_to_top.attr('title', 'Вниз').addClass('back-down');
            $.scrollTo(0 , 700,  { axis: 'y' } );
        }
    });

    $(window).on('scroll', function() {
        if(window.scrollY > 100){
            if( !is_show ){
                scroll_to_top.removeClass('hidden');
                is_show = true;
            }
        }else{
            if( is_show ){
                scroll_to_top.addClass('hidden');
                is_show = false;
            }
        }

        if( last_position < window.scrollY){
            if( scroll_to_top.hasClass('back-down') ){
                scroll_to_top.removeClass('back-down');
            }
        }
        last_position = window.scrollY;
    });




    $('.js-show-more-prices').click(function () {
        $('.prices-section .hidden').removeClass('hidden').addClass('showed');
        $('.js-show-more-prices').parent().hide();
        $('.js-show-less-prices').parent().show();
        return false;
    });
    $('.js-show-less-prices').click(function () {
        $('.prices-section .showed').removeClass('showed').addClass('hidden');
        $('.js-show-more-prices').parent().show();
        $('.js-show-less-prices').parent().hide();
        return false;
    });

    $('.js-show-more-models').click(function () {
        $('.prices-tabbed_models-list').addClass('expanded');
        $('.js-show-more-models').parent().hide();
        $('.js-show-less-models').parent().show();
        return false;
    });
    $('.js-show-less-models').click(function () {
        $('.prices-tabbed_models-list').removeClass('expanded');
        $('.js-show-more-models').parent().show();
        $('.js-show-less-models').parent().hide();
        return false;
    });
    if ($('.prices-tabbed_models-list').length) {
        resetShowMoreModels();
        $(window).on('resize', function () {
            resetShowMoreModels();
        });

        function resetShowMoreModels() {
            if ($('.prices-tabbed_models-list')[0].scrollHeight > $('.prices-tabbed_models-list')[0].clientHeight) {
                $('.js-show-more-models').parent().show();
            } else {
                $('.js-show-more-models').parent().hide();
            }
        }
    }



    function panelsReset() {
        $('.popup').hide();
        $('#js-show-call-form').show();
        $('#js-popup-phones').show();
        $('#js-call-form').hide();
        $('#js-popup-overlay').remove();
    }
    $('.header_contacts-smm .link').click(function () {
        panelsReset();
        $(this).next('.popup').show();

        $('<div class="popup-overlay" id="js-popup-overlay"> </div>').appendTo("body").click(function () {
            panelsReset();
        });

        return false;
    });
    /*$(document).click(function() {
        panelsReset();
    });*/
    $('.popup .close').click(function () {
        panelsReset();
        return false;
    });
    $('#js-show-call-form').click(function () {
        $(this).hide();
        $('#js-popup-phones').hide();
        $('#js-call-form').show();
        return false;
    });

    $('#js-popup-dialog_open').click(function () {
        /*var widget_id = 'Ubb6YRJdub';
        var date = new Date(0);
        document.cookie = "jv_client_name_"+widget_id+"=; path=/; expires=" + date.toUTCString();*/

        jivo_api.setContactInfo({
            "name": $('#js-popup-dialog_name').val()
        });
        jivo_api.open();

        panelsReset();
        return false;
    });

    /*if ($.cookie("geo-city") != undefined) {
        selectCity($.cookie("geo-city"));
    } else {
        ymaps.ready(init);
    }

    function init() {
        var current = '1'; // Брянск
        var geolocation = ymaps.geolocation;
        if (geolocation && geolocation.region == 'Орловская область') {
            current = '2'; // Орёл
        } else if (geolocation && geolocation.region == 'Воронежская область') {
            current = '3'; // Воронеж
        } else {
            current = '1'; // Брянск
        }
        selectCity(current);
    }

    function selectCity(city) {
        //$('.js-geo-dependent').hide();
        //if ($.cookie("express-news") == undefined && city == 'orel') {
        //  $(".js-express-news").show();
        //}
        if ($.cookie("express-news") == undefined) {
            $('.express-news_item').addClass('hide');
            $('.express-news_item[data-city="'+city+'"]').removeClass('hide');

            if (($('.express-news_item:not(".hide")').length > 0)) {
                $(".js-express-news").removeClass('hide');
            } else {
                $(".js-express-news").addClass('hide');
            }
        }

        $('.geo-dependent').hide();
        $('.header_city a').removeClass('active');

        $('.geo-dependent[data-city="'+city+'"]').show();
        $('.header_city a[data-city="'+city+'"]').addClass('active');

        $.cookie("geo-city", city, { expires: 7, path: '/' });
    }

    $(".header_city a").click(function( event ) {
        var current = $(this).data('city');
        selectCity(current);
        return false;
    });*/

});

jQuery(document).ready(function () {
    //$('.reviews .item').matchHeight();
    function initReviews() {
        $(".reviews .text-wrapper").each(function(i) {
            if ($(this).height() > 65) {
                $(this).height(65);
                $(this).parent().append('<div class="text-expand"><span role="button">Читать весь отзыв</span></div>').show();
            }
        });
    }
    $(document.body).on('click', '.reviews .text-expand span', function(e) {
        var thisElement = $(this);
        var textElement = $(this).parent().prev();
        var expanded = textElement.attr('data-expanded');
        if (expanded == 1) {
            textElement.animate({height: '65px'}, 500 );
            textElement.attr('data-expanded', 0);
            setTimeout(function() { thisElement.text('Читать весь отзыв'); }, 300);
        } else {
            textElement.animate({height: textElement.get(0).scrollHeight}, 500 );
            textElement.attr('data-expanded', 1);
            setTimeout(function() { thisElement.text('Свернуть'); }, 300);
        }
        return false;
    });

    $('.reviews .owl-carousel').owlCarousel({
        loop: false,
        margin: 20,
        nav: true,
        navText: '',
        dots: false,
        responsive:{
            0:{
                items: 1
            },
            1280:{
                items: 2
            }
        },
        onInitialized: initReviews
    });


    $('.menu-slider-section .list').owlCarousel({
        loop: false,
        //rewind: true,
        margin: 0,
        nav: true,
        navText: '',
        dots: false,
        responsive:{
            0:{
                items: 1,
                loop:( $('.menu-slider-section .list .item').length > 1 )
            },
            320:{
                items: 2,
                loop:( $('.menu-slider-section .list .item').length > 2 )
            },
            1024:{
                items: 3,
                loop:( $('.menu-slider-section .list .item').length > 3 )
            },
            1280:{
                items: 4,
                loop:( $('.menu-slider-section .list .item').length > 4 )
            }
        }

    });

    $('.spoiler-body').hide();
    $('.spoiler-title').click(function() {
        $('.spoiler-title').not(this).parent().removeClass('opened');
        $('.spoiler-title').not(this).parent().find('.spoiler-body').hide(300);

        $(this).parent().toggleClass('opened');
        $(this).parent().find('.spoiler-body').slideToggle(300);
    });

    /*if ($('.container').width() > 900) {
        var added = false;
        var i = $(".header-main").offset().top + $(".header-main").height();
        $(window).scroll(function () {
            if ($(window).scrollTop() > i) {

                $(".header").addClass("fixed")
                height = $(".header-main").height();

                if (!added) {
                    var spacerElement = '<div id="fixed_header_spacer" style="height: ' + height + 'px;"></div>';
                    $(".header").parent().prepend(spacerElement);
                    added = true;
                    //alert(height);
                }
            } else {
                if (added) {
                    $("#fixed_header_spacer").remove();
                    added = false;
                }
                $(".header").removeClass("fixed");
            }
        });
    }*/
});
